module.exports = __webpack_public_path__ + "static/media/1011803.60aac60f.png";